const DEFAULT_NUMBER_OF_DIGITS = 1;

export const computeRoundedValueFor = (
    number: number,
    numberOfDigits: number = DEFAULT_NUMBER_OF_DIGITS
) => {
    const roundMultiplier = Math.pow(10, numberOfDigits);

    return Math.round(number * roundMultiplier) / roundMultiplier;
};
